module.exports = __webpack_public_path__ + "img/mima.b49da8fe.png";